import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpService } from './http.service';
import { HttpParams } from '@angular/common/http';
import { UserService } from './user.service';

@Injectable()
export class ProductsService {

    private url: string = environment.base_url;

    constructor(
        private httpService: HttpService,
        private userService: UserService
    ) {
    }

    search(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/products', httpParams).map(resp => resp);
    }

    get(productId: number) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.get(this.url + '/b2b/products/' + productId + '?include=supplier_info', httpParams).map(resp => resp);
    }

    incrementToCart(productId: number) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.post(this.url + '/b2b/cart/' + productId + '/1?include=product.cart_detail', {}, httpParams).map(resp => resp);
    }

    overwriteCart(productId: number, qty: number) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.put(this.url + '/b2b/cart/' + productId + '/' + qty + '?include=product.cart_detail', {}, httpParams).map(resp => resp);
    }

    deleteCartItem(productId: number) {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.delete(this.url + '/b2b/cart/' + productId + '/?include=product.cart_detail', httpParams).map(resp => resp);
    }

    getCartItems(httpParams: HttpParams = new HttpParams()) {
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        const include = 'items.product.cart_detail';
        const exclude = '';
        return this.httpService.get(this.url + '/b2b/cart/?include=' + include + '&exclude=' + exclude, httpParams).map(resp => resp);
    }

    clearCart() {
        let httpParams: HttpParams = new HttpParams();
        httpParams = httpParams.set('company', this.userService.getCompany()['id']);
        return this.httpService.delete(this.url + '/b2b/cart/clear/', httpParams).map(resp => resp);
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/services/products.service.ts